import { Component, computed } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NotificationBaseComponent } from './notification-base/notification-base.component';

/**
 * Hydrated by Notification.Api from Enrollment.Api (EnrollmentListItem shape) — only the fields the
 * template needs are typed here. `languageLevels` is a "/"-separated display string.
 */
interface IEnrollmentAssignedData {
	languageName: string;
	languageLevels: string;
}

@Component({
	standalone: true,
	imports: [RouterModule, NotificationBaseComponent],
	selector: 'lb-notification-enrollment-assigned',
	template: `<lb-notification-base [notification]="notification()">
		<div activity-message>
			is your new
			<b>
				{{ enrollment()?.languageName }}
				{{ enrollment()?.languageLevels }}
			</b>
			student!
		</div>
		<div activity-action>
			<button md-button (click)="dismissNotifications()">Dismiss</button>
		</div>
	</lb-notification-base>`,
	styleUrls: ['./notification-base-shared.component.scss']
})
export class NotificationEnrollmentAssignedComponent extends NotificationBaseComponent {
	enrollment = computed(() => this.notification().data as IEnrollmentAssignedData);
}
